export const projectRoutes = {
  edit: "edit",
  styling: "styling",
  plusButtonOptions: "plus-button",
  quickActions: "quick-actions",
  integrations: "integrations",
  integrationZiezodan: "integrations/ziezodan",
  integrationRems: "integrations/rems",
  integrationRemsAddresses: "integrations/rems/addresses",
  integrationRemsResidents: "integrations/rems/residents",
  integrationHomeDna: "integrations/homedna",
  integrationDico: "integrations/dico",
  integrationOutlook: "integrations/outlook",
  integrationJim: "integrations/jim",
  integrationIqbi: "integrations/iqbi",
  integrationMyPup: "integrations/mypup",
  integrationBringme: "integrations/bringme",
  integrationCopilot: "integrations/copilot",
  integrationSwoogo: "integrations/swoogo",
  integrationOfficeRnd: "integrations/officernd",
  integrationHubSpot: "integrations/hubspot",
  integrationHealthDistrict: "integrations/healthdistrict",
  integrationWunderbricks: "integrations/wunderbricks",
  integrationILoq: "integrations/iloq",
  integrationJansenHuybregts: "integrations/jansen-huybregts",
} as const;
